/**
 * Swiper carousel selector constants
 * Used across carousel sections for consistent navigation and pagination targeting
 *
 * @typedef {Object} SwiperSelectors
 * @property {string} BUTTON_NEXT - Default Swiper next button (.swiper-button-next)
 * @property {string} BUTTON_PREV - Default Swiper prev button (.swiper-button-prev)
 * @property {string} CONTAINER - Swiper container element (.swiper)
 * @property {string} NEXT_BUTTON - Custom next button (.swiper-next-button)
 * @property {string} PAGINATION - Swiper pagination container (.swiper-pagination)
 * @property {string} PREV_BUTTON - Custom prev button (.swiper-prev-button)
 * @property {string} SCROLLBAR - Swiper scrollbar container (.swiper-scrollbar)
 * @property {string} SLIDE - Individual slide element (.swiper-slide)
 * @property {string} WRAPPER - Swiper wrapper element (.swiper-wrapper)
 */

/**
 * @type {SwiperSelectors}
 */
const SWIPER_SELECTORS = {
  BUTTON_NEXT: '.swiper-button-next',
  BUTTON_PREV: '.swiper-button-prev',
  CONTAINER: '.swiper',
  NEXT_BUTTON: '.swiper-next-button',
  PAGINATION: '.swiper-pagination',
  PREV_BUTTON: '.swiper-prev-button',
  SCROLLBAR: '.swiper-scrollbar',
  SLIDE: '.swiper-slide',
  WRAPPER: '.swiper-wrapper',
};

export { SWIPER_SELECTORS };
